const notificationDirectives = angular.module('notificationDirectives', []);

notificationDirectives.directive('notificationList', function(
  notificationService,
  $timeout,
  $uibModal,
  accountService,
  userViewService,
  eventsExportService,
  $translate,
  eventService,
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/notification/notification-list-module.html',
    scope: {
      settings: '=',
      criteria: '=',
      area: '=',
      filters: '=',
      defaultSelection: '=',
      gridlet: '=',
    },
    link: function(scope) {
      const contentAreaId = 'div#scrollContainer';

      scope.sortType = 'activated';
      scope.sortReverse = false;
      scope.selection = {};
      scope.smallFont = false;

      scope.accordionStatus = {
        open: false,
      };

      scope.loadBusy = false;
      scope.notifications = [];

      scope.$watch('accordionStatus.open', function() {
        adjustContentSize(scope.area, contentAreaId);
      });

      scope.removeFilters = function() {
        scope.selection.values = {};
      };

      let searchChanged = false;
      scope.$watch('search', function() {
        searchChanged = true;
        scope.loadNotifications();
      });

      scope.$watchCollection('selection.values', function() {
        scope.loadNotifications();
      });

      scope.setSortType = function(column) {
        if (scope.sortType === column) {
          scope.sortReverse = !scope.sortReverse;
        } else {
          scope.sortType = column;
          scope.sortReverse = true;
        }
        scope.loadNotifications();
      };

      /*scope.showDeactive = function() {
                scope.selection.values.deactive = !scope.selection.values.deactive;
                scope.loadNotifications();
            };*/

      function adjustContentSize(selectorId, contentAreaSelectorId) {
        $timeout(function() {
          const selectorIdHeight = $(selectorId).height();
          if (selectorIdHeight > 100) {
            $(contentAreaSelectorId).height(selectorIdHeight - 50);
          }
          if (scope.settings.fullscreen) {
            const advancedSearchHeight = $(
              '.gridletFullscreenAdvancedSearch'
            ).height();
            $(contentAreaSelectorId).height(
              selectorIdHeight - 93 - advancedSearchHeight
            );
          }
          scope.areaWidth = $(contentAreaSelectorId).width();
          scope.smallFont = scope.areaWidth < 580;

          // $("div.notificationTitleContainer").width(scope.areaWidth);
        }, 200);
      }

      $(window).resize(function() {
        if (scope.area) {
          adjustContentSize(scope.area, contentAreaId);
        }
      });

      scope.scrollElementTop = function(element) {
        if (element) {
          $(element).animate({ scrollTop: 0 }, 'fast');
        }
      };

      function updateCriteria() {
        if (
          typeof emu !== 'undefined' &&
          (typeof emu === 'string' || emu instanceof String)
        ) {
          scope.criteria.emu = emu;
        }
        scope.criteria.sortType = scope.sortType.toUpperCase();
        scope.criteria.reverse = scope.sortReverse;
        if (searchChanged) {
          scope.criteria.searchString = scope.search;
        }
        scope.criteria.searchChanged = searchChanged;

        let selection = {};
        if (
          Object.keys(scope.selection.values).length !== 0 &&
          _.some(scope.selection.values)
        ) {
          selection = scope.selection.values;
        } else {
          selection = angular.copy(scope.defaultSelection.values);
        }
        scope.criteria.emuFilter = selection.emu;
        scope.criteria.carFilter = selection.car;
        scope.criteria.eventIdFilter = selection.eventId;
        scope.criteria.activatedFilter = selection.activated;
        scope.criteria.deactivatedFilter = selection.deactivated;
        scope.criteria.ackFilter = selection.ack;
        scope.criteria.nameFilter = selection.name;
        scope.criteria.deactiveFilter = selection.deactive;
        scope.criteria.trainFilter = selection.train;
        scope.criteria.userFilterType = 'ALL'; // removed, old alarms functionality
        scope.criteria.userSectorId = null; // removed, old alarms functionality
        scope.criteria.count = scope.settings.fullscreen ? 30 : 15;
        searchChanged = false;
      }

      scope.$on('gridlet-update-data', function() {
        scope.loadNotifications();
      });

      // TODO: Do we need to reload the events when entering fullscreen?
      // scope.$watch('settings.fullscreen', function(newVal) {
      //   if (!newVal) {
      //     scope.selection = angular.copy(scope.defaultSelection);
      //     scope.search = '';
      //     scope.accordionStatus.open = false;
      //   }
      //   $timeout(scope.loadNotifications(), 600);
      // });

      scope.openNotification = function(notificationItem) {
        const modalInstance = $uibModal.open({
          templateUrl: '/modules/modals/notification-module.html',
          controller: 'notificationModalController',
          windowClass: 'medium-size-modal',
          resolve: {
            notificationItem: function () {
              return notificationItem;
            },
          },
        });
        modalInstance.result.then(
          function(reload) {
            if (reload) {
              scope.loadNotifications();
            }
          },
          function() {}
        );
      };

      scope.loadNotifications = function() {
        scope.loadBusy = true;
        updateCriteria();
        const criteria = angular.copy(scope.criteria);
        if (
          scope.notifications.length > 0 &&
          criteria.count < scope.notifications.length
        ) {
          criteria.count = scope.notifications.length;
        }
        notificationService.latest(criteria).then(
          function(data) {
            if (!angular.equals(scope.notifications, data)) {
              scope.notifications = data;
              if (!scope.settings.fullscreen) {
                scope.scrollElementTop(contentAreaId);
              }
            }
            adjustContentSize(scope.area, contentAreaId);
            scope.dataLoading = false;
            scope.loadBusy = false;
          },
          function() {
            scope.notifications.length = 0;
            scope.loadBusy = false;
          }
        );
      };

      scope.loadNotificationsPage = function() {
        if (scope.loadBusy) {
          return;
        }
        scope.loadBusy = true;
        const criteria = angular.copy(scope.criteria);
        criteria.skip = scope.notifications.length || 0;
        notificationService.latest(criteria).then(function(data) {
          angular.forEach(data, function(item) {
            if (![scope.notifications].includes(item)) {
              scope.notifications.push(item);
            }
          });
          adjustContentSize(scope.area, contentAreaId);
          if (data.length > 0) {
            scope.loadBusy = false;
          }
        });
      };

      scope.exportToExcel = function() {
        updateCriteria();
        const criteria = angular.copy(scope.criteria);
        criteria.skip = 0;
        if (
          scope.notifications.length > 0 &&
          criteria.count < scope.notifications.length
        ) {
          criteria.count = scope.notifications.length;
        }
        eventsExportService.exportToExcel(
          criteria,
          $translate.instant('export.latest-events')
        );
      };

      scope.exportToCsv = function() {
        updateCriteria();
        const criteria = angular.copy(scope.criteria);
        criteria.skip = 0;
        if (
          scope.notifications.length > 0 &&
          criteria.count < scope.notifications.length
        ) {
          criteria.count = scope.notifications.length;
        }
        eventsExportService.exportToCsv(
          criteria,
          $translate.instant('export.latest-events')
        );
      };

      scope.$emit('gridlet-register-export', {
        excel: scope.exportToExcel,
        csv: scope.exportToCsv,
      });

      function init() {
        scope.dataLoading = true;
        if (scope.area) {
          scope.areaWidth = $(contentAreaId).width();
          adjustContentSize(scope.area, contentAreaId);
        }
        scope.fullScreenToggeled = false;
        scope.selection = angular.copy(scope.defaultSelection);
        scope.search = '';
        updateCriteria();
        // scope.loadNotifications();
      }

      init();
    },
  };
});
